export default {
  balanceAndgoldenPocket: 'Balance / goldenPocketBalance',
  enableGoldenPocket: 'Open GoldenPocket',
  GoldenPocketStatus: 'GoldenPocket Status',
  goldenPocket: 'GoldenPocket',
  goldenPocketTotalBlance: 'GoldenPocket total balance',
  GoldenPocketClose: 'Closed',
  GoldenPocketOpen: 'Opened',
  NotGoldenPocket: 'Not available',
  createMomoOrder: 'Create MoMo withdrawal order',
  createZaloOrder: 'Create  Zalo withdrawal order',
  createVIETTELOrder: 'Create VIETTEL withdrawal order',
  home: 'Home',
  login: 'Log in',
  confirmLogout: 'Are you sure to log out',
  register: 'Register',
  logout: 'Sign out',
  username: 'Username',
  name: 'Name',
  password: 'Password',
  enterPassword: 'Please enter the password.',
  submit: 'Submit',
  search: 'Search',
  option: 'Option',
  new: 'Create',
  edit: 'Edit',
  cancelEdit: 'Restored to original value',
  delete: 'Delete',
  warning: 'Warning',
  week: 'A week',
  mount1: 'Last a months ',
  mount3: 'Last three months',
  to: 'To',
  startDate: 'Start Date',
  endDate: 'End Date',
  confirmDelete: 'Are you sure to delete this item?',
  yes: 'Yes',
  cancel: 'No',
  success: 'Success',
  fail: 'Failed',
  doActive: 'Active',
  cancelActive: 'Cancel active',
  active: 'Active',
  unActive: 'UnActive',
  init: 'Init',
  normal: 'Normal',
  expired: 'Expired',
  open: 'Open',
  close: 'Close',
  online: 'Online',
  outline: 'Outline',
  faceline: 'Need CCCD Verify',
  locked: 'Locked',
  serial: 'Serial',
  enterSerial: 'Please enter the serial code.',
  amount: 'Amount',
  balance: 'Balance',
  desc: 'Description',
  remark: 'Remark',
  status: 'Status',
  createDate: 'Create Date',
  createBy: 'Create By',
  updateDate: 'Update Date',
  updateBy: 'Update By',
  resend: 'Resend',
  reset: 'Reset',
  choose: 'Please select',
  opened: 'Open successfully',
  closed: 'Close successfully',
  pullBalance: 'Balance',
  supplier: 'Supplier',
  placeholder: 'Please input',
  bankInfo: 'Bank account information',
  trueName: 'Account real name',
  inBalance: 'Deposit',
  outBalance: 'Dispensing',
  payment: 'Payment',
  cancelPayment: 'Cancel payment',
  openPayment: 'open payment',
  BindingSession: 'Binding Session',
  Binding: 'Binding',

  homePage: {
    globalLang: 'Global lang',
    fontSize: 'Font size',
    sizeDefault: 'Default',
    sizeMedium: 'Medium',
    sizeSmall: 'Small',
    sizeMini: 'Mini'
  },
  changePwd: {
    title: 'Change password',
    confirmPwd: 'Confirm password',
    pwdPlaceholderAgain: 'Please enter the password again'
  },
  momo: {
    title: 'Momo account',
    list: {
      title: 'Momo List',
      phoneNo: 'Phone',
      manager: 'Manager',
      receive: 'Receiving',
      inline: 'Is online',
      noEdit: 'The Phone number has been restored to the original value',
      initSuccess: 'Initialization is successful, whether to register this device?',
      registerSuccess: 'Registration is successful, whether to continue submit the OTP for device?',
      createSuccess: 'The device is created successfully, whether to initialize the device?',
      withdrawalLimit: 'Withdrawal limit',
      fixedWithdrawalLimit: 'Fixed withdrawal limit',
      autoReceive: 'Auto Receive',
      todayReceive: 'Today receive amount',
      monthReceive: 'Month receive amount',
      dayWithdrawnAmount: 'Day Withdrawn amount',
      withdrawnAmount: 'Withdrawn amount',
      withdrawalTotalFee: 'Withdrawn total fee',
      step1: 'Base info',
      step2: 'initialize',
      step3: 'Register',
      step4: 'Finish',
      otpTip: 'Please enter 4-digit pure digital OTP code',
      vtpotpTip: 'Please enter 4-digit pure digital OTP code',
      zaloOtpTip: 'Please enter 6-digit pure digital OTP code',
      googleTip: 'Please enter the 6-digit Google verification code',
      node: '* Note if you are opening the app, please exit the app (both in background mode). After clicking "Create New", please reopen the app to connect.',
      activeTip: 'The current device is activated, are you sure to deactivate the device',
      unActiveTip: 'The current device is not activated, are you sure to activate the device',
      activeSuccess: 'Activated successfully!',
      unActiveSuccess: 'Successfully deactivated!',
      batchActiveTip: 'Are you sure to activate the selected device?',
      openReceiveTip: 'Confirm to enable automatic payment?',
      closeReceiveTip: 'Confirm to turn off automatic collection?',
      closeTip: 'Are you sure you want to turn off automatic payment?',
      openTip: 'Are you sure to enable automatic payment?',
      paymentSuccess: 'Automatic payment is enabled',
      paymentFail: 'Automatic payment has been turned off',
      payment: 'Payment',
      session: 'Enter OTP code'
    },
    onlineList: {
      title: 'Activated list'
    }
  },
  transaction: {
    title: 'Momo Transaction',
    createOrder: {
      title: 'Create Withdrawal',
      tkMomoAccount: 'Withdrawal from Account',
      toMomoAccount: 'Withdrawal to Account',
      tkMomoTip: 'Please choose a Momo account',
      toMomoTip: 'Please enter the receive account.',
      type: 'Withdrawal type',
      typeTip: 'Please select a withdrawal type',
      bank: 'Select bank account',
      bankTip: 'Please select a bank',
      tip: 'Withdraw to another bank',
      withdrawAmount: 'Withdraw amount',
      amountTip: 'Please enter the withdrawal amount',
      amount50w: 'The amount of external transfer cannot be less than 50,000',
      amount1w: 'The amount of external transfer cannot be less than 10,000',
      amount100: 'The account transfer amount cannot be less than 100',
      node: '* Please check the information carefully before submitting',
      cancelTrans: 'You canceled the withdrawal request.',
      transactionNo: 'TransactionNo',
      transactionContent: 'Receipt message',
      maxWithdrawal: 'Maximum Withdrawal Amount',
      calculationFormula: 'Calculation Formula'
    },
    receive: {
      title: 'LS Receive',
      date: 'Date',
      gdCode: 'GD Code',
      receiveAccount: 'Receive Account',
      depositAccount: 'Deposit Account',
      receiveTime: 'Receive Time',
      scanTime: 'Scan time'
    },
    redpack: {
      openTime: 'Open Time'
    },
    withdrawal: {
      title: 'LS Withdrawal',
      amountTotal: 'Total(Amount)',
      feeTotal: 'Total(Fee)',
      date: 'Date',
      gdCode: 'GD Code',
      depositAccount: 'Deposit Account',
      receiveAccount: 'Receive Account',
      cost: 'Cost',
      total: 'Total',
      perAmount: 'Before Balance',
      proAmount: 'After Balance',
      type: 'Type',
      author: 'Operator',
      optionTime: 'Option Time',
      serial: 'Serial',
      systemNo: 'System code'
    }
  },
  bankManage: {
    title: 'Momo Bank',
    addNew: {
      title: 'Add bank account',
      tkMomoTip: 'Please enter the Momo account',
      bankNumber: 'Account No.',
      accountNoTip: 'Please enter the correct account number',
      bank: 'Owned Bank',
      bankTip: 'Please select a bank',
      tkNameTip: 'TK name cannot be empty',
      bankName: 'Bank Name',
      bankNameTip: 'Bank name cannot be empty',
      bankNameSort: 'Bank Name(Sort)',
      bankNameSortTip: 'Bank name(Sort) cannot be empty',
      bankCode: 'Bank Code',
      bankCodeTip: 'Bank code cannot be empty',
      node: '* Please check the information carefully before submitting'
    },
    list: {
      title: 'Bank List',
      id: 'ID',
      tkMomo: 'TK Momo',
      accountNo: 'Bank Account No.',
      bankName: 'Bank name',
      userQL: 'Created by',
      options: 'Option'
    }
  },
  administrator: {
    title: 'Admin Management',
    addNew: {
      title: 'Add manager',
      account: 'Login account',
      phone: 'Phone',
      password: 'Password',
      confirmPwd: 'Confirm password',
      group: 'Role',
      selectGroup: 'Select role',
      nameTip: 'Username can not be empty.',
      accountTip: 'Login account can not be empty.',
      phoneTip: 'phone can not be empty.',
      passwordTip: 'Password can not be empty.',
      configPwdTip: 'Please enter password again.',
      groupTip: 'Role can not be empty.'
    },
    list: {
      title: 'Manager list',
      id: 'ID',
      createBy: 'Create By',
      lastLoginTime: 'Last Login date'
    },
    ip: {
      title: 'IP Manage',
      ipTip: 'Please enter the IP address.',
      usernameTip: 'Please enter the manager username'
    },
    logs: {
      title: 'Account Error Log',
      serialNo: 'Serial No',
      serialNumber: 'Device No',
      errorMsg: 'Error Message'
    }
  },
  roleManager: {
    title: 'Role manage',
    roleName: 'Role name',
    role: {
      title: 'Create role',
      roleNameTip: 'Please enter the role name.',
      setting: 'Permission set',
      reLogin: 'Successfully, Please login again!'
    },
    roleList: {
      title: 'Role list'
    },
    permission: {
      title: 'Permission Management'
    }
  },
  transactionTypes: {
    1: 'Internal transfer',
    2: 'Transfer to external',
    7: 'GoldenPocket',
    72: 'GoldenPocketRelated',
    73: 'GoldenPocketInternal'
  },
  zalo: {
    list: {
      title: 'Zalo Account Manage'
    },
    trans: {
      title: 'Zalo Transaction'
    },
    bank: {
      title: 'Zalo Bank Manage',
      phone: 'Zalo Phone No.',
      account: 'Account'
    }
  },
  vtp: {
    list: {
      title: 'VTP Account Manage'
    },
    trans: {
      title: 'VTP Transaction'
    },
    bank: {
      title: 'VTP Bank Manage',
      phone: 'VTP Phone No.',
      account: 'Account'
    }
  },
  momoQr: {
    list: {
      title: 'MOMOQR Account Manage'
    },
    trans: {
      title: 'MOMOQR Transaction'
    },
    bank: {
      title: 'MOMOQR Bank Manage',
      phone: 'MOMOQR Phone No.',
      account: 'Account'
    }
  },
  waiting: 'Please wait, downLoading. . . .',
  up: 'ascending order',
  down: 'descending order',
  disActive: 'freeze',
  sortField: 'Sort field',
  limitPlaceHolder: 'Please enter withdrawal limit',
  needInput: 'Please enter valid data',
  abRecords: {
    title: 'AbnormalRecords'
  },
  lastAccept: 'Last payment time',
  sumBalance: 'Total balance',
  version: 'Version Number',
  paymentTime: 'Payment Time',
  orderNo: 'Order No',
  paymentAccount: 'Payment Account',
  paymentAccountType: 'Payment Account Type',
  transId: 'Transaction ID',
  paymentStatus: 'Payment Status',
  paymentRemark: 'Payment Remark',
  export: 'Export',
  import: 'Import',
  downloadTemplate: 'Download Template',
  paymentSupplier: 'Payment Supplier',
  paymentAmount: 'Payment Amount',
  DateCreated: 'Creation Time',
  creator: 'Creator',
  DateModified: 'Modification Time',
  modifier: 'Modifier',
  Upload: 'Upload',
  close: 'Close',
  confirm: 'Confirm',
  state1: 'Waiting for Payment',
  state2: 'Payment Successful',
  state3: 'Paid',
  state4: 'Payment Failed',
  waiting: 'Waiting...',
  downLoad: {
    a1: 'Please download the template file first',
    a2: 'Please upload the template file',
    selectfile: 'Select file',
    ImportSuccess: 'Import successful',
    Importfailed: 'Import failed'
  },
  utilityStatus: 'utility Status',
  WalletBalance: 'Wallet Balance'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/common.js